e4.nav = {
    global: {
        init: function () {
            e4.nav.global.bindEvents();
        },
        bindEvents: function () {
            var jNav = jQuery( '.js-e-nav' ),
                jHeader = jQuery( '.js-e-header' ),
                jNavToggle = jQuery( '.js-e-nav-toggle' );
            jNavToggle.on( 'click', function ( event ) {
                event.preventDefault();
                event.stopPropagation();
                jNav.modal( 'toggle' );
            } );
            jNav.on( 'swipeleft', function () {
                jNav.modal( 'hide' );
            } ).on( 'show.bs.modal', function () {
                jHeader.addClass( 'reset-transform-containing-block' );
            } ).on( 'hide.bs.modal', function () {
                jHeader.removeClass( 'reset-transform-containing-block' );
            } ).on( 'shown.bs.modal', e4.nav.global.revealActivePath ).on( 'hidden.bs.modal', e4.nav.global.resetActivePath ).on( 'click', 'a', e4.nav.global.toggleCollapseAndDropdown );
        },
        revealActivePath: function () {
            var jNav = jQuery( '.js-e-nav' ),
                jNavItemActive = jNav.find( '.nav-link.is-active' ).last(),
                jNavItemActiveParent = jNavItemActive.closest( '.nav' ).closest( '.nav-item' ),
                jOffsetElement = jNavItemActiveParent,
                intScrollTarget = 0;
            jQuery( '.js-e-nav-global' ).find( '.nav-link.is-inpath' ).filter( '[data-collapse-target]' ).each( function () {
                jQuery( this.getAttribute( 'data-collapse-target' ) ).addClass( 'show' );
            } );
            if ( jNavItemActive.length === 1 && e4.util.isInViewport( jNavItemActive ) === false ) {
                setTimeout( function () {
                    // Hvis parent item ikke findes, eller er for høj til viewport, sættes offset element til det
                    // aktive item.
                    if ( jNavItemActiveParent.length === 0 || jNavItemActiveParent.height() > jNav.height() ) {
                        jOffsetElement = jNavItemActive;
                    }
                    // Beregn relativt offset til containeren.
                    intScrollTarget = jOffsetElement.offset().top - jNav.offset().top;
                    jNav.animate( {
                        scrollTop: intScrollTarget
                    }, Math.floor( intScrollTarget * e4.settings.nav.revealActive.speed ), e4.settings.nav.revealActive.easing );
                }, e4.settings.nav.revealActive.delay );
            }
        },
        resetActivePath: function () {
            var jNav = jQuery( '.js-e-nav' );
            jNav.scrollTop( 0 );
            jNav.removeAttr( 'style' );
            jNav.find( '.js-e-nav-global' ).find( '.nav-link.is-inpath' ).filter( '[data-collapse-target]' ).each( function () {
                jQuery( this.getAttribute( 'data-collapse-target' ) ).removeClass( 'show' );
            } );
        },
        toggleCollapseAndDropdown: function ( event ) {
            var jThis = jQuery( event.currentTarget );
            if ( jThis.is( '.modal.show [data-toggle="dropdown"]' ) === true ) {
                event.stopPropagation();
            }
            if ( jThis.is( '.modal.show [data-collapse-toggle="true"]' ) === true ) {
                event.preventDefault();
                jQuery( jThis.data( 'collapse-target' ) ).collapse( 'toggle' );
            }
        }
    },
    local: {
        horizontal: {
            init: function () {
                var jNavLocalHorizontal = jQuery( '.js-e-nav-local-horizontal.is-sticky' );
                if ( jNavLocalHorizontal.length === 1 ) {
                    e4.nav.local.horizontal.isRAF = false;
                    jNavLocalHorizontal.removeClass( 'is-sticky' );
                    e4.nav.local.horizontal.intialOffsetTop = jNavLocalHorizontal.offset().top;
                    jNavLocalHorizontal.addClass( 'is-sticky' );
                    e4.nav.local.horizontal.bindEvents();
                    e4.nav.local.horizontal.toggleSticky();
                }
            },
            bindEvents: function () {
                jQuery( window ).on( 'scroll', function () {
                    if ( e4.nav.local.horizontal.isRAF === false ) {
                        window.requestAnimationFrame( function () {
                            e4.nav.local.horizontal.toggleSticky();
                            e4.nav.local.horizontal.isRAF = false;
                        } );
                        e4.nav.local.horizontal.isRAF = true;
                    }
                } );
            },
            toggleSticky: function () {
                if ( jQuery( window ).scrollTop() > e4.nav.local.horizontal.intialOffsetTop ) {
                    jQuery( '.js-e-nav-local-horizontal' ).addClass( 'is-stuck' );
                }
                else {
                    jQuery( '.js-e-nav-local-horizontal' ).removeClass( 'is-stuck' );
                }
            }
        },
        vertical: {
            init: function () {
                var jNavLocalVertical = jQuery( '.js-e-nav-local-vertical' );
                if ( jNavLocalVertical.length === 1 ) {
                    if ( jNavLocalVertical.is( '.is-sticky' ) === true ) {
                        e4.nav.local.vertical.intialOffsetTop = jNavLocalVertical.next().offset().top;
                        e4.nav.local.vertical.stickyOffsetTop = jQuery( '.js-e-header' ).height();
                        if ( jNavLocalVertical.outerHeight( true ) + e4.nav.local.vertical.stickyOffsetTop > jQuery( window ).height() ) {
                            jNavLocalVertical.removeClass( 'is-sticky' );
                        }
                        else {
                            jNavLocalVertical.css( 'top', e4.nav.local.vertical.intialOffsetTop );
                            e4.nav.local.vertical.bindEvents();
                            e4.nav.local.vertical.toggleSticky();
                        }
                    }
                    e4.nav.local.vertical.setContentHeight();
                }
            },
            bindEvents: function () {
                e4.nav.local.vertical.isRAF = false;
                jQuery( window ).on( 'scroll', function () {
                    if ( e4.nav.local.vertical.isRAF === false ) {
                        window.requestAnimationFrame( function () {
                            e4.nav.local.vertical.toggleSticky();
                            e4.nav.local.vertical.isRAF = false;
                        } );
                        e4.nav.local.vertical.isRAF = true;
                    }
                } ).on( 'resize', e4.util.debounce( function () {
                    e4.nav.local.vertical.setContentHeight();
                }, e4.settings.debounceDelay.resize ) );
            },
            toggleSticky: function () {
                var jContent = jQuery( '.e-content' ),
                    jContentArticle = jContent.find( '.e-content-article' ).first(),
                    jNavLocalVertical = jQuery( '.js-e-nav-local-vertical' ),
                    intWindowScrollTop = jQuery( window ).scrollTop(),
                    intContentMainBottom = Math.floor( jContentArticle.offset().top + jContent.height() ),
                    intNavLocalVerticalHeight = Math.ceil( jNavLocalVertical.height() );
                if ( intWindowScrollTop > e4.nav.local.vertical.intialOffsetTop ) {
                    jNavLocalVertical.addClass( 'is-stuck' );
                    jNavLocalVertical.css( 'top', e4.nav.local.vertical.stickyOffsetTop );
                    if ( intWindowScrollTop + intNavLocalVerticalHeight >= intContentMainBottom ) {
                        jNavLocalVertical.addClass( 'has-reached-bottom' );
                    }
                    else {
                        jNavLocalVertical.removeClass( 'has-reached-bottom' );
                    }
                }
                else {
                    jNavLocalVertical.removeClass( 'is-stuck' );
                    jNavLocalVertical.css( 'top', e4.nav.local.vertical.intialOffsetTop );
                }
            },
            setContentHeight: function () {
                jQuery( '.e-content' ).css( 'min-height', function () {
                    var intNavLocalHeight = parseInt( jQuery( '.js-e-nav-local-vertical' ).outerHeight( true ) ) || 0,
                        intContentPaddingTop = parseInt( window.getComputedStyle( this ).getPropertyValue( 'padding-top' ) ) || 0,
                        intContentPaddingBottom = parseInt( window.getComputedStyle( this ).getPropertyValue( 'padding-bottom' ) ) || 0;
                    return intNavLocalHeight > 0 ? intContentPaddingTop + intNavLocalHeight + intContentPaddingBottom : '';
                } );
            }
        }
    },
    util: {
        init: function () {
            jQuery( '.js-e-nav-pageicon-language' ).each( function ( intIndex, domElement ) {
                var jThis = jQuery( domElement ),
                    arrClassList = jThis.parent().attr( 'class' ).split( ' ' ),
                    strLangISO = '';
                for ( var c = 0; c < arrClassList.length; c++ ) {
                    if ( arrClassList[ c ].indexOf( 'icon-flag-' ) === 0 ) {
                        strLangISO = arrClassList[ c ].split( '-' )[ 2 ];
                        jThis.css( 'background-image', 'url(' + e4.settings.nav.flagCDN + strLangISO + '.svg)' );
                    }
                }
            } );
        }
    }
};

